import Vue from 'vue'
import HtmlRenderer from '@/components/shared/HtmlRenderer/index.vue'

Vue.component('html-renderer', HtmlRenderer)
